import { render, staticRenderFns } from "./NewUserMenu.vue?vue&type=template&id=4e3a49a7&"
import script from "./NewUserMenu.vue?vue&type=script&lang=js&"
export * from "./NewUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports